import React from 'react';
import ReactDOM from 'react-dom';
import { Field,formValueSelector,reduxForm } from 'redux-form';
import Select from 'react-select';
import { connect } from 'react-redux'
import LoadingSmall from '../../../components/LoadingSmall.js';
import Helpers from '../../../helpers/General.js';

const validate = values => {
    const errors = {}

    if (!values.CHAT_TEXT_SEND) {
        errors.CHAT_TEXT_SEND = 'Required'
    }

    if (!values.CHAT_TEXT_TYPE_MESSAGE) {
        errors.CHAT_TEXT_TYPE_MESSAGE = 'Required'
    }

    if (!values.CHAT_TEXT_EMAIL) {
        errors.CHAT_TEXT_EMAIL = 'Required'
    }

    if (!values.CHAT_TEXT_NAME) {
        errors.CHAT_TEXT_NAME = 'Required'
    }

    if (!values.CHAT_HEADER_MAXIMIZED_TEXT) {
        errors.CHAT_HEADER_MAXIMIZED_TEXT = 'Required'
    }




    return errors
}

const renderField = ({ input, name,className,placeholder, title, type, meta: { touched, error } }) => (

    <div className={`form-group form-material floating ${touched && error ? 'has-danger':''}`} data-plugin="formMaterial">
        <input {...input}  placeholder={placeholder} name={name} className={className} type={type}/>
        <label className="floating-label">{title}</label>
        <small className="text-help">{touched && ((error && <span>{error}</span>))}</small>
    </div>
)

const select = ({ input, options,name,className,placeholder, title, type, meta: { touched, error } }) => (
    <div className={`form-group form-material floating ${touched && error ? 'has-danger':''}`} data-plugin="formMaterial">
        <select name={name} className="form-control" value={input.value} onChange={input.onChange}>
            {options.map((item,i) => {
                return <option key={i} value={item.value}>{item.label}</option>
            })}
        </select>
        <label className="floating-label">{title}</label>
        <small className="text-help">{touched && ((error && <span>{error}</span>))}</small>
    </div>
)



class PushTranslation extends React.Component {


    render() {
        const { handleSubmit } = this.props;
        return (
            <form onSubmit={handleSubmit}>
                <div className="row">


                    <div className="row">
                        <div className="col-sm-12">
                            <h5>Notification box</h5>
                        </div>

                        <div className="col-sm-12">
                            <Field component={renderField} type="text" placeholder="Allow" name="PUSH_BUTTON_DECLINE"  className="form-control" title="Allow button" />
                        </div>
                        <div className="col-sm-12">
                            <Field component={renderField} type="text" placeholder="No thanks" name="PUSH_BUTTON_ACCEPT"  className="form-control" title="Decline button" />
                        </div>

                        <div className="col-sm-12">
                            <Field component={renderField} type="text" placeholder="We want to send you notifications about new offers, sales and upcoming events." name="PUSH_HEADER_TEXT"  className="form-control" title="Box header" />
                        </div>
                        <div className="col-sm-12">
                            <Field component={renderField} type="text" placeholder="You can easily disable notifications in your browser settings." name="PUSH_DESKTOP_TEXT"  className="form-control" title="Box subheader" />
                        </div>

                        <div className="col-sm-12">
                            <h5>Subscription window</h5>
                        </div>

                        <div className="col-sm-12">
                            <Field component={renderField} type="text" placeholder='Click "Allow" to subscribe to our notifications' name="PUSH_TEXT_UNSUBSCRIBED_HEADER"  className="form-control" title="Instructions" />
                        </div>
                        <div className="col-sm-12">
                            <Field component={renderField} type="text" placeholder="You can close this window" name="PUSH_TEXT_SUBSCRIBED_SUB"  className="form-control" title="Close window message" />
                        </div>
                        <div className="col-sm-12">
                            <Field component={renderField} type="text" placeholder="You'll now get notifications from us." name="PUSH_TEXT_SUBSCRIBED_HEADER"  className="form-control" title="Subscribe successful" />
                        </div>
                    </div>


                    <div className="row m-t-20">
                        <div className="col-sm-12">
                            {
                                this.props.isSavingTranslation
                                    ?
                                    <LoadingSmall />
                                    :
                                    <button type="submit" className="btn btn-dark btn-block">Update</button>
                            }
                        </div>
                    </div>
                </div>

            </form>
        );
    }
}

const mapStateToProps = (state, ownProps) => ({

});


// Decorate the form component
PushTranslation = reduxForm({
    form: 'PushTranslation',
    validate,
})(PushTranslation);

PushTranslation = connect(
    state => ({
        initialValues: {
            PUSH_TEXT_UNSUBSCRIBED_HEADER: state.general.settings.PUSH_TEXT_UNSUBSCRIBED_HEADER,
            PUSH_TEXT_SUBSCRIBED_SUB: state.general.settings.PUSH_TEXT_SUBSCRIBED_SUB,
            PUSH_TEXT_SUBSCRIBED_HEADER: state.general.settings.PUSH_TEXT_SUBSCRIBED_HEADER,
            PUSH_BUTTON_DECLINE: state.general.settings.PUSH_BUTTON_DECLINE,
            PUSH_BUTTON_ACCEPT: state.general.settings.PUSH_BUTTON_ACCEPT,
            PUSH_DESKTOP_TEXT: state.general.settings.PUSH_DESKTOP_TEXT,
            PUSH_HEADER_TEXT: state.general.settings.PUSH_HEADER_TEXT,

        }
    })
)(PushTranslation)

export default PushTranslation;


// WEBPACK FOOTER //
// ./containers/settings/form/PushTranslation.js